import { useConfigurationContext } from "../../root/ConfigurationContext";
import type { DealStage } from "../../types";
import { useOffers } from "../useOffers";

// Etiquetas de las etapas de offers.stages (las de Atomic vienen de la configuración)
const LABELS: Record<string, string> = {
  nuevo: "Nuevo",
  contactado: "Contactado",
  conversacion: "Conversación",
  interesado: "Interesado",
  entrevista: "Entrevista",
  diagnostico: "Diagnóstico",
  demo: "Demo",
  piloto: "Piloto",
  preventa: "Preventa",
  propuesta: "Propuesta",
  onboarding: "Onboarding",
  activo: "Activo",
  ganado: "Ganado",
  perdido: "Perdido",
};

export const stageLabel = (stage: string) =>
  LABELS[stage] ?? stage.charAt(0).toUpperCase() + stage.slice(1);

/**
 * Etapas del pipeline: las de la oferta si se indica (columnas del kanban),
 * si no las de la configuración de Atomic.
 */
export const useOfferStages = (
  offerId?: number | string | null,
): DealStage[] => {
  const { dealStages } = useConfigurationContext();
  const { data: offers } = useOffers();
  const offer = offers?.find((o) => String(o.id) === String(offerId ?? ""));
  return offer
    ? offer.stages.map((s) => ({ value: s, label: stageLabel(s) }))
    : dealStages;
};

/** Etiqueta de cualquier etapa (de Atomic o de una oferta). */
export const useStageLabel = () => {
  const { dealStages } = useConfigurationContext();
  return (stage: string) =>
    dealStages.find((s) => s.value === stage)?.label ?? stageLabel(stage);
};

// Etapa → variable de color (--st-*) y si el texto va oscuro (fondos claros)
const STAGE_COLOR: Record<string, [string, boolean?]> = {
  nuevo: ["--st-nuevo", true],
  contactado: ["--st-contactado"],
  conversacion: ["--st-conversacion"],
  interesado: ["--st-conversacion"],
  entrevista: ["--st-conversacion"],
  diagnostico: ["--st-conversacion"],
  demo: ["--st-demo", true],
  piloto: ["--st-demo", true],
  onboarding: ["--st-demo", true],
  preventa: ["--st-demo", true],
  propuesta: ["--st-propuesta", true],
  ganado: ["--st-ganado"],
  activo: ["--st-ganado"],
  perdido: ["--st-perdido"],
};

/** [variable CSS del color, texto oscuro] de una etapa; etapas nuevas usan morado. */
export const stageColor = (stage: string): [string, boolean?] =>
  STAGE_COLOR[stage] ?? ["--st-conversacion"];
